<template>
  <div>
    <sport-header v-if="0" :title="$route.params.infoType"/>
    <pre-loader v-if="loading"/>
    <div v-if="$store.state.isMobile" class="content p-3 geoff-bg-main" >
      <div class="fw-600 fs-20 text-center mb-3">{{ $route.params.infoType }}</div>
      <div v-html="htmlContent"></div>
    </div>
    <div v-else class="content-desktop pt-4">
      <div class="fs-24 text-center fw-600">{{ $route.params.infoType }}</div>
      <div class="p-3 content-desktop" v-html="htmlContent"></div>
    </div>
    <div> 
      <vue-modal class="info-modal" ref="modal" @close="setShowInfoInModal(false)">
        <template v-slot:default>
          <div class="modal-win-header">{{ $route.params.infoType }}</div>
          <div class="p-3 modal-win-content" v-html="htmlContent"></div>
        </template>
      </vue-modal>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import VueModal from "@/components/UI/VueModal";
  import SportHeader from "@/components/Sport/SportHeader";
  import PreLoader from "@/components/UI/PreLoader";
  export default {
    name: "InfoPageView",
    components: {
      VueModal,
      PreLoader,
      SportHeader
    },
    data:()=>{
      return{
        loading: false,
        htmlContent: ''
      }
    },
    computed: {
      ...mapGetters(['USER', 'SHOW_INFO_IN_MODAL']),
      showOverallModal() {
        return this.SHOW_INFO_IN_MODAL && this.USER?.isAcceptTermsModal && !this.loading
      }
    },
    watch:{
      showOverallModal () {
        this.initModal()
      },
      '$route.params.infoType'(){
        if (this.$route.name === 'info'){
          this.htmlContent = ''
          this.init()
          document.getElementById('scroll-content').scrollTo(0,0)
        }
      }
    },
    mounted(){
      this.init()
      this.initModal()
    },
    methods:{
      init(){
        let pageName = ''
        switch (this.$route.params.infoType){
          case 'Terms And Conditions':
            pageName = 'termsandconditions'
            break
          case 'Privacy Policy':
            pageName = 'privacy'
            break
          case 'Cookie Policy':
            pageName = 'cookies'
            break
          case 'Affiliates':
            pageName = 'affiliates'
            break
          case 'Betting Rules':
            pageName = 'bettingrule'
            break
          case 'About Us':
            pageName = 'aboutus'
            break
          case 'Contact Details':
            pageName = 'contact-detail'
            break
          case 'Best Odds Guaranteed':
            pageName = 'BOG'
            break
          case 'Help':
            pageName = 'help'
            break
        }
        if (!pageName) pageName = this.$route.params.infoType
        this.loadContent(pageName)
      },
      loadContent(pageName){
        const vm = this
        vm.loading = true
        vm.API.getPageData(pageName).then((res)=>{
          if (res.data?.length){
            vm.htmlContent = res.data[0]?.content.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&')
          } else {
            vm.$toast.error('Page not found!')
          }
        })
        .catch(error=>vm.$toast.error(error))
        .finally(()=>vm.loading = false)
      },

      initModal(){
        this.SHOW_INFO_IN_MODAL && this.USER?.isAcceptTermsModal && !this.loading
        if (this.showOverallModal) {
          this.openModal()
        }
      },
      openModal() {
        this.$refs.modal.open()
      },
      closeModal() {
        this.$refs.modal.close()
      },
      setShowInfoInModal(val) {
        this.$store.dispatch('SET_SHOW_INFO_IN_MODAL', val)
      }
    }
  }
</script>

<style scoped lang="scss">
  .content{
    top: 3.5rem;
    right: 0;
    left: 0;
    bottom: 3.5rem;
    overflow-y: scroll;
  }
  .content-desktop{
    /* background: #FFFFFF; */
    background: var(--geoff-bg-section);
    border-radius: 0.3rem;
  }

  .info-modal {
    z-index: 1200;

    .modal-win-header {
      text-align: center;
      width: 100%;
      display: block;
      font-size: 1.5rem;
      font-weight: 700;
    }

    .modal-win-content {
      overflow: scroll;
      max-height: 70vh;
    }
  }
</style>